import {createSlice} from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    isAuthenticated: false,
    loggedTime:''

  },
  reducers: {
    onLogin: (state, action) => {
      state.user = action.payload.user;
      state.isAuthenticated = true;
      state.loggedTime=new Date().toLocaleDateString('en-US');
    },
    onLogout: (state, action) => {
      state.token = '';
      state.isAuthenticated = false;
      state.user = {};
      state.loggedTime=new Date().toLocaleDateString('en-US');


    },
    updateUserState: (state, action) => {
      state.user.firstName = action.payload.firstName;
      state.user.lastName = action.payload.lastName;
      state.user.email = action.payload.email;
      state.user.phone = action.payload.phone;
    },
    updateFacility: (state, action) => {
      state.user.facility = action.payload.facility;
    },
    updateAccess: (state, action) => {
      state.facilityAccess = action.payload ?? {};
    },
  },
});

export const selectUsers = (state) => state.users;

export const {
  onLogin,
  onLogout,
  updateUserState,
  updateFacility,
  updateAccess,
} = userSlice.actions;

export default userSlice.reducer;
